import { Anchor, FormattedText } from "client/Components";
import { AlertManager, getAlertManagerOutsideReact } from "client/Hooks";
import { localize } from "./culture";

export function showPopupBlockedAlert(
	url: string | undefined,
	target: string | undefined
): void {
	const alertManager: AlertManager = getAlertManagerOutsideReact();

	if (url) {
		alertManager.showWarning(
			<FormattedText
				text={localize("_ThePopupIsBlockedByTheBrowserWithUrl")}
				thingsToReplace={[
					{
						what: "{{Here}}",
						filler: (
							<Anchor
								href={url}
								target={target || "_blank"}
							>
								{localize("_Here")}
							</Anchor>
						)
					}
				]}
			/>
		);
	} else {
		alertManager.showWarning(
			localize("_ThePopupIsBlockedByTheBrowser")
		);
	}
}
